import axios from 'utils/axios';

export const onlineSignPatientServicePackageDocs = (patientServicePackageId:string) => {
  return axios.post(`/api/v1/servicepackages/patient/${patientServicePackageId}/documents/sign`);
};
